export const useLanguage = () => {
  return { language: localStorage.getItem("lang") };
};
